<button class="agenx-button" [ngClass]="currentClasses" [disabled]="disabled">
  <p class="agenx-button__text">{{ buttonText }}</p>
  <picture class="agenx-button__loading">
    <img class="agenx-button__loading-icon" [src]="icon_loading_src" alt="Loading Icon">
  </picture>
</button>
